var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivepricingicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8491 5.26424V5.73509C10.8485 6.83872 10.4911 7.91259 9.83028 8.79653C9.16947 9.68046 8.24063 10.3271 7.18229 10.64C6.12394 10.953 4.9928 10.9154 3.95756 10.5329C2.92231 10.1504 2.03844 9.44357 1.43775 8.51772C0.83707 7.59188 0.55176 6.49666 0.624375 5.39542C0.696991 4.29418 1.12364 3.24591 1.8407 2.40695C2.55775 1.568 3.52679 0.983313 4.60329 0.740092C5.67979 0.49687 6.80608 0.608147 7.81417 1.05733",
    stroke: "url(#paint0_linear_1855_1336)",
    strokeWidth: 1.2283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19922 5.23878L5.73459 6.77415L10.8525 1.65625",
    stroke: "url(#paint1_linear_1855_1336)",
    strokeWidth: 1.2283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1855_1336",
    x1: 0.613281,
    y1: 5.73216,
    x2: 10.8491,
    y2: 5.73216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54B27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186639"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1855_1336",
    x1: 4.19922,
    y1: 4.2152,
    x2: 10.8525,
    y2: 4.2152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54B27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186639"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivepricingicon);
export default __webpack_public_path__ + "static/media/active pricing icon.342511891e72f4e530cf40d7b85ecae6.svg";
export { ForwardRef as ReactComponent };